// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Em produção, silencia o console para evitar vazamento de informações sensíveis
// em ferramentas de desenvolvedor do navegador.
if (process.env.NODE_ENV === 'production') {
  console.log   = () => {};
  console.debug = () => {};
  console.info  = () => {};
  console.warn  = () => {};
  // console.error é preservado para captura de erros críticos inesperados
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
